(function(){
  var roots = document.querySelectorAll('.fl-cs');
  var root = roots[roots.length - 1];
  if(!root || root.dataset.csInit) return;
  root.dataset.csInit = '1';

  (function hideChrome(){
    var ownSection = root.closest('.shopify-section, .shopify-section-group-header-group, .shopify-section-group-footer-group, [class*="shopify-section-group"]');
    var keep = ownSection;
    var keepGroup = ownSection ? ownSection.closest('[class*="shopify-section-group"]') : null;
    var nodes = document.querySelectorAll('body > .shopify-section, body > [class*="shopify-section-group"], body > .shopify-section-group-header-group, body > .shopify-section-group-footer-group');
    nodes.forEach(function(n){
      if(n === keep || n === keepGroup) return;
      if(keep && n.contains(keep)) return;
      n.style.setProperty('display', 'none', 'important');
    });
    var more = document.querySelectorAll('header.site-header, header.section-header, .site-header, .header, .announcement-bar, .announcement, .utility-bar, .top-bar, .topbar, .promo-bar, .marquee, footer.site-footer, footer.section-footer, .site-footer, .footer');
    more.forEach(function(n){ if(keep && n.contains(keep)) return; n.style.setProperty('display','none','important'); });
  })();

  /* Countdown */
  var target = Date.UTC(2026, 4, 7, 19, 0, 0);
  var box = root.querySelector('[data-cs-countdown]');
  if(box){
    var d=box.querySelector('[data-d]'),h=box.querySelector('[data-h]'),m=box.querySelector('[data-m]'),s=box.querySelector('[data-s]');
    function pad(n){return n<10?'0'+n:''+n;}
    function tick(){
      var diff = target - Date.now(); if(diff<0) diff=0;
      d.textContent = pad(Math.floor(diff/86400000));
      h.textContent = pad(Math.floor(diff%86400000/3600000));
      m.textContent = pad(Math.floor(diff%3600000/60000));
      s.textContent = pad(Math.floor(diff%60000/1000));
    }
    tick(); setInterval(tick,1000);
  }

  /* Scroll-jack carousel — native CSS sticky + JS translates track on scroll */
  var pin = root.querySelector('[data-cs-pin]');
  var pinSticky = pin && pin.querySelector('.fl-cs__pinSticky');
  var track = root.querySelector('[data-cs-track]');
  var progressEl = root.querySelector('[data-cs-progress]');
  var indexEl = root.querySelector('[data-cs-index]');
  var shotsAll = root.querySelectorAll('.fl-cs__shot');
  if(pin && pinSticky && track){
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function measure(){
      if(reduce){ pin.style.height = 'auto'; return; }
      var travel = Math.max(0, track.scrollWidth - window.innerWidth);
      if(travel <= 0){
        pin.style.height = window.innerHeight + 'px';
        pin.dataset.travel = '0'; pin.dataset.range = '0';
        track.style.transform = 'translate3d(0,0,0)';
        return;
      }
      var slow = 1.6, hold = Math.round(window.innerHeight * 0.4);
      pin.style.height = (window.innerHeight + travel * slow + hold) + 'px';
      pin.dataset.travel = String(travel);
      pin.dataset.range = String(travel * slow);
    }

    var ticking = false;
    function update(){
      ticking = false;
      if(reduce) return;
      var travel = parseFloat(pin.dataset.travel || '0');
      var range  = parseFloat(pin.dataset.range  || '0');
      if(travel <= 0 || range <= 0) return;
      var rect = pin.getBoundingClientRect();
      var scrolled = Math.max(0, -rect.top);
      var p = Math.min(1, scrolled / range);
      track.style.transform = 'translate3d(' + (-p * travel) + 'px, 0, 0)';
      var pBar = Math.min(1, scrolled / (pin.offsetHeight - window.innerHeight));
      if(progressEl) progressEl.style.transform = 'scaleX(' + pBar + ')';
      if(indexEl && shotsAll.length){
        var center = window.innerWidth / 2, closest = 1, cd = Infinity;
        shotsAll.forEach(function(el, i){
          var r = el.getBoundingClientRect(); var c = r.left + r.width/2;
          var d = Math.abs(c - center);
          if(d < cd){ cd = d; closest = i + 1; }
        });
        indexEl.textContent = closest < 10 ? '0' + closest : '' + closest;
      }
    }
    function onScroll(){ if(!ticking){ window.requestAnimationFrame(update); ticking = true; } }
    function onResize(){ measure(); update(); }

    var imgsList = track.querySelectorAll('img');
    var pending = imgsList.length;
    function imgDone(){ pending--; if(pending <= 0) onResize(); }
    imgsList.forEach(function(img){ if(img.complete) imgDone(); else { img.addEventListener('load', imgDone); img.addEventListener('error', imgDone); } });
    if(!imgsList.length) onResize();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    setTimeout(onResize, 200);
    setTimeout(onResize, 1200);
  }
  /* Progress bar + ticker */
  var prog = root.querySelector('[data-zd-progress]');
  var nowEl = root.querySelector('#zd-count-now');
  var leftEl = root.querySelector('#zd-count-left');
  var fillEl = root.querySelector('.zd-progress__fill');
  var BASE = parseInt(root.dataset.prebookBase || '80247', 10);
  var CAP  = parseInt(root.dataset.prebookCap  || '100000', 10);
  function fmt(n){ return n.toLocaleString('en-US'); }
  function setCounts(n){
    if(nowEl) nowEl.textContent = fmt(n);
    if(leftEl) leftEl.textContent = fmt(Math.max(0, CAP-n));
    if(fillEl) fillEl.style.width = Math.min(100, n/CAP*100) + '%';
  }
  setCounts(BASE);
  if(prog && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          if(fillEl){ fillEl.style.width = '0%'; void fillEl.offsetWidth; fillEl.style.width = (BASE/CAP*100) + '%'; }
          io.unobserve(e.target);
        }
      });
    }, {threshold: 0.4});
    io.observe(prog);
  }
  var current = BASE;
  setInterval(function(){ if(current >= CAP - 50) return; current += 1; setCounts(current); }, 25000 + Math.random()*20000);

  /* Smooth scroll from Reserve buttons in sticky bar */
  root.querySelectorAll('a[href="#zd-checkout"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var t = document.getElementById('zd-checkout');
      if(!t) return;
      e.preventDefault();
      t.scrollIntoView({behavior:'smooth', block:'start'});
      var firstInput = t.querySelector('input, select');
      if(firstInput) setTimeout(function(){ firstInput.focus({preventScroll:true}); }, 600);
    });
  });

  /* Quantity stepper */
  var qtyInput = root.querySelector('#zd-qty');
  var lineEl = root.querySelector('#zd-line');
  var lineQtyEl = root.querySelector('#zd-line-qty');
  var totalEl = root.querySelector('#zd-total');
  var UNIT = 2500;
  function recalc(){
    if(!qtyInput) return;
    var q = Math.max(1, Math.min(5, parseInt(qtyInput.value||'1',10) || 1));
    qtyInput.value = q;
    if(lineQtyEl) lineQtyEl.textContent = q;
    if(lineEl) lineEl.textContent = 'Rs ' + (UNIT*q).toLocaleString('en-US');
    if(totalEl) totalEl.textContent = 'Rs ' + (UNIT*q).toLocaleString('en-US');
  }
  root.querySelectorAll('.zd-qty__btn').forEach(function(b){
    b.addEventListener('click', function(){
      if(!qtyInput) return;
      var step = parseInt(b.dataset.qty||'0',10);
      qtyInput.value = (parseInt(qtyInput.value||'1',10) || 1) + step;
      recalc();
    });
  });
  recalc();

/* Render booking number from localStorage in success state */
  var okNum = root.querySelector('#zd-ok-num');
  if(okNum){
    try {
      var n = parseInt(localStorage.getItem('zd-prebook-num')||'0', 10);
      if(n>0){ okNum.textContent = '#' + n.toLocaleString('en-US'); try { localStorage.setItem('zd-prebook-num','0'); } catch(e){} }
    } catch(e){}
    if(/[?&]customer_posted=true/i.test(window.location.search)){
      requestAnimationFrame(function(){ setTimeout(function(){ okNum.scrollIntoView({behavior:'smooth', block:'center'}); }, 120); });
    }
  }
})();


/* === Video gallery: per-tile sound toggle === */
(function(){
  var tile = document.querySelector('[data-zd-vid]');
  if(!tile) return;
  var v = tile.querySelector('.zd-vid__el');
  var btn = tile.querySelector('[data-zd-vid-sound]');
  var lbl = tile.querySelector('[data-zd-vid-label]');
  var iconMuted = tile.querySelector('[data-icon="muted"]');
  var iconUnmuted = tile.querySelector('[data-icon="unmuted"]');
  if(!v || !btn) return;
  v.muted = true; var p = v.play(); if(p && p.then) p.catch(function(){});
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    if(v.muted){ v.muted = false; v.volume = 0.85; if(lbl) lbl.textContent = 'Sound on'; if(iconMuted) iconMuted.style.display='none'; if(iconUnmuted) iconUnmuted.style.display=''; }
    else { v.muted = true; if(lbl) lbl.textContent = 'Tap for sound'; if(iconMuted) iconMuted.style.display=''; if(iconUnmuted) iconUnmuted.style.display='none'; }
  });
})();


/* === Top reel: aggressive autoplay + sound toggle === */
(function(){
  var b = document.querySelector('[data-zd-banner]');
  if(!b) return;
  var v = b.querySelector('.zd-banner__el');
  var btn = b.querySelector('[data-zd-banner-sound]');
  var lbl = b.querySelector('[data-zd-banner-label]');
  var iM = b.querySelector('[data-icon="muted"]');
  var iU = b.querySelector('[data-icon="unmuted"]');
  if(!v) return;

  v.muted = true;
  v.setAttribute('muted','');
  v.setAttribute('playsinline','');
  v.setAttribute('webkit-playsinline','');

  function tryPlay(){
    var p = v.play();
    if(p && typeof p.then === 'function'){ p.catch(function(){}); }
  }
  // Try repeatedly: on metadata, on canplay, on loadeddata, on first interaction, on visibility
  ['loadedmetadata','canplay','loadeddata'].forEach(function(ev){
    v.addEventListener(ev, tryPlay, { once:false });
  });
  tryPlay();

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ tryPlay(); }
        else { try { v.pause(); } catch(_){} }
      });
    }, { threshold: 0.2 });
    io.observe(b);
  }

  // First user interaction unblocks playback in browsers that defer it
  function firstTouch(){ tryPlay(); document.removeEventListener('click', firstTouch, true); document.removeEventListener('touchstart', firstTouch, true); }
  document.addEventListener('click', firstTouch, true);
  document.addEventListener('touchstart', firstTouch, true);

  // Sound toggle (only if button exists)
  if(btn){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      if(v.muted){ v.muted=false; v.volume=0.85; if(lbl) lbl.textContent='Sound on'; if(iM) iM.style.display='none'; if(iU) iU.style.display=''; }
      else{ v.muted=true; if(lbl) lbl.textContent='Tap for sound'; if(iM) iM.style.display=''; if(iU) iU.style.display='none'; }
      tryPlay();
    });
  }
})();


/* === Top-level Quantity stepper delegate === */
(function(){
  var UNIT = 2500;
  function recalc(){
    var qty = document.getElementById('zd-qty');
    if(!qty) return;
    var q = Math.max(1, Math.min(5, parseInt(qty.value || '1', 10) || 1));
    qty.value = q;
    var lineQ = document.getElementById('zd-line-qty');
    var line  = document.getElementById('zd-line');
    var total = document.getElementById('zd-total');
    if(lineQ) lineQ.textContent = q;
    if(line)  line.textContent  = 'Rs ' + (UNIT*q).toLocaleString('en-US');
    if(total) total.textContent = 'Rs ' + (UNIT*q).toLocaleString('en-US');
  }
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest && e.target.closest('.zd-qty__btn');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var qty = document.getElementById('zd-qty');
    if(!qty) return;
    var step = parseInt(btn.dataset.qty || '0', 10);
    var cur  = parseInt(qty.value || '1', 10) || 1;
    qty.value = Math.max(1, Math.min(5, cur + step));
    recalc();
  }, true);
  // also recalc when user types in the qty input directly
  document.addEventListener('input', function(e){
    var qty = e.target && e.target.id === 'zd-qty' ? e.target : null;
    if(qty) recalc();
  });
  // initial
  recalc();
})();


/* === Global window.zdQty: ironclad qty stepper called from inline onclick === */
window.zdQty = function(step){
  var qty = document.getElementById('zd-qty');
  if(!qty) return;
  var cur = parseInt(qty.value || '1', 10);
  if(isNaN(cur)) cur = 1;
  var next = step === 0 ? cur : cur + step;
  next = Math.max(1, Math.min(5, next));
  qty.value = next;
  var lineQ = document.getElementById('zd-line-qty');
  var line  = document.getElementById('zd-line');
  var total = document.getElementById('zd-total');
  var amt = 'Rs ' + (2499 * next).toLocaleString('en-US');
  if(lineQ) lineQ.textContent = next;
  if(line)  line.textContent  = amt;
  if(total) total.textContent = amt;
};
// Run once on load to sync summary to current qty value
if(document.readyState !== 'loading') window.zdQty(0);
else document.addEventListener('DOMContentLoaded', function(){ window.zdQty(0); });

/* === CRO: live counter drift (deterministic, modest) === */
(function(){
  var nowEl = document.getElementById('zd-count-now');
  var leftEl = document.getElementById('zd-count-left');
  if(!nowEl) return;
  var fmt = function(n){ return n.toLocaleString('en-US'); };
  var current = parseInt((nowEl.textContent||'80247').replace(/[^\d]/g,''),10) || 80247;
  var cap = 100000;
  // Drift up by 1 reservation every 22-58s, never past cap-1500 so price stays "Rs 2,499"
  function tick(){
    var ceiling = cap - 1500;
    if(current >= ceiling) return;
    current += 1;
    nowEl.textContent = fmt(current);
    if(leftEl){ leftEl.textContent = fmt(Math.max(0, cap - current)); }
    var pct = Math.min(100, Math.round((current/cap)*100));
    var fill = document.querySelector('.zd-progress__fill');
    if(fill){ fill.style.width = pct + '%'; }
    schedule();
  }
  function schedule(){
    var delay = 22000 + Math.floor(Math.random()*36000);
    setTimeout(tick, delay);
  }
  schedule();
})();

/* === CRO: top action buttons (clean rebuild) ===
   ATC -> add via Cart API, then navigate to /cart
   Buy Now -> clear cart, add this product, navigate to /checkout
*/
(function(){
  function getForm(){ return document.getElementById('zd-product-form'); }
  function getVariantId(){
    var f = getForm(); if(!f) return null;
    var v = f.querySelector('input[name="id"]'); return v ? v.value : null;
  }
  function buildProperties(){
    var f = getForm(); if(!f) return {};
    var props = {};
    f.querySelectorAll('input[name^="properties["]').forEach(function(inp){
      var m = inp.name.match(/^properties\[(.+)\]$/);
      if(m) props[m[1]] = inp.value;
    });
    return props;
  }
  function clearStuck(btn){
    if(!btn) return;
    btn.classList.remove('is-loading');
    btn.disabled = false;
  }

  var topCart = document.getElementById('zd-cart-btn-top');
  if(topCart && !topCart.dataset.bound){
    topCart.dataset.bound = '1';
    topCart.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var id = getVariantId();
      if(!id){ console.warn('[zd] no variant id; falling back to /cart'); window.location.href='/cart'; return; }
      topCart.classList.add('is-loading');
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id:id, quantity:1, properties: buildProperties() })
      })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('add ' + r.status)); })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(err){
        console.warn('[zd] ATC fetch failed, native fallback:', err);
        clearStuck(topCart);
        var f = getForm();
        if(f){ f.action = '/cart/add'; f.submit(); }
        else { window.location.href = '/cart'; }
      });
    });
  }

  var topBuy = document.getElementById('zd-buy-btn-top');
  if(topBuy && !topBuy.dataset.bound){
    topBuy.dataset.bound = '1';
    topBuy.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var id = getVariantId();
      if(!id){ window.location.href='/checkout'; return; }
      topBuy.classList.add('is-loading');
      // Step 1: clear cart, then add this product, then go to checkout
      fetch('/cart/clear.js', { method:'POST', headers:{'Accept':'application/json'} })
        .then(function(){
          return fetch('/cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ id:id, quantity:1, properties: buildProperties() })
          });
        })
        .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('add ' + r.status)); })
        .then(function(){ window.location.href = '/checkout'; })
        .catch(function(err){
          console.warn('[zd] Buy Now fetch failed, hard-redirect fallback:', err);
          clearStuck(topBuy);
          window.location.href = '/cart/clear?return_to=' + encodeURIComponent('/cart/add?id=' + id + '&quantity=1&return_to=/checkout');
        });
    });
  }
})();
